var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLoggedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00ab54",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00ab54",
    fillOpacity: 1,
    d: "M491.1 425.8c0 26.5-8.5 47.8-24.7 63.1s-37.5 23-64 23H110.5c-27.3 0-48.6-7.7-64.9-23-16.2-15.4-24.7-36.7-24.7-63.1 0-11.9 0-23 .9-34.1.9-11.1 2.6-23 4.3-36.7s5.1-24.7 8.5-35.8c3.4-11.1 8.5-22.2 14.5-32.4s12.8-19.6 20.5-27.3c7.7-7.7 17.1-13.7 28.2-17.9s23.9-6.8 37.5-6.8c1.7 0 6.8 2.6 13.7 6.8s15.4 10.2 24.7 16.2c9.4 6 21.3 11.1 35.8 16.2 14.5 5.1 29.9 6.8 44.4 6.8s29.9-2.6 44.4-6.8c14.5-5.1 26.5-10.2 35.8-16.2 9.4-6 17.9-11.1 24.7-16.2 6.8-5.1 11.9-6.8 13.7-6.8 13.7 0 25.6 2.6 37.5 6.8s20.5 10.2 28.2 17.9c7.7 7.7 14.5 16.2 20.5 27.3 6 11.1 11.1 21.3 14.5 32.4 3.4 11.1 6.8 23 8.5 35.8 1.7 12.8 4.3 24.7 4.3 36.7s5.1 22.2 5.1 34.1zM384.4 128c0 35-12.8 65.7-37.5 90.5-24.7 24.7-55.5 37.5-90.5 37.5s-65.7-12.8-90.5-37.5-37.5-55.5-37.5-90.5 12.8-65.7 37.5-90.5S221.4 0 256.4 0s65.7 12.8 90.5 37.5c24.7 24.8 37.5 55.5 37.5 90.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLoggedIn);
export default __webpack_public_path__ + "static/media/user_logged_in.5b3b5eff0ce049b22e49e05c94cb720f.svg";
export { ForwardRef as ReactComponent };